export default __webpack_public_path__ + "static/media/C.e2cb509e.jpg";